import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Icons } from '@beeline/design-tokens/js/iconfont';

import { BookingObjectAttribute } from 'src/components/BookingObjectAttribute/BookingObjectAttribute';
import { Section } from 'src/components/Section/Section';
import {
  getParkingLocation,
  getParkingTimePeriodLocal,
} from 'src/store/parking/selectors';
import { ParkingBookingData } from 'src/types';
import { formatDate } from 'src/utils/formatDate';
import { formatTime } from 'src/utils/formatTime';
import { getDateTime } from 'src/utils/getDateTime';

export interface TimeIntervalProps {
  status: ParkingBookingData | null | undefined;
}

export const TimeInterval: FC<TimeIntervalProps> = ({ status }) => {
  const { town } = useSelector(getParkingLocation);
  const { from: settingsFrom, to: settingsTo } = useSelector(
    getParkingTimePeriodLocal,
  );

  const { date, time } = useMemo(() => {
    let from = status?.bookedFrom;
    let to = status?.bookedTo;
    if (from) {
      const fromDate = getDateTime({
        date: new Date(from),
        timezoneOffset: town?.timeZone,
      });
      from = fromDate.toISOString();
    }
    if (to) {
      const toDate = getDateTime({
        date: new Date(to),
        timezoneOffset: town?.timeZone,
      });
      to = toDate.toISOString();
    }
    from = from ? from : settingsFrom;
    to = to ? to : settingsTo;

    return {
      date: from ? formatDate(new Date(from)) : null,
      time:
        from && to
          ? `${formatTime(new Date(from))} — ${formatTime(new Date(to))}`
          : null,
    };
  }, [
    settingsFrom,
    settingsTo,
    status?.bookedFrom,
    status?.bookedTo,
    town?.timeZone,
  ]);

  return date && time ? (
    <Section title='Дата и время бронирования' testId='parkingDateSection'>
      <BookingObjectAttribute testId='parkingDate' iconName={Icons.Calendar}>
        {date}
      </BookingObjectAttribute>
      <BookingObjectAttribute testId='parkingTime' iconName={Icons.Clock}>
        {time}
      </BookingObjectAttribute>
    </Section>
  ) : null;
};
